<template>
  <header class="page-header">
    <h1>Companies</h1>

    <div class="page-button-group">
      <GuLink v-if="canManageCompanies" variant="link" :to="{ name: 'companies:history' }">
        History
      </GuLink>
    </div>
  </header>

  <GuDatagridServer :config="config" :site-config-name="siteConfigName" class="mx-5" />
</template>

<script setup>
import { GuLink } from '@shared/gu-components/link'

import { GuDatagridServer } from '@gu-datagrid-new'
import { COMPANIES_DASHBOARD_CONFIG } from '@shared/constants/siteContent'
import { COMPANIES_API } from '@companies/api/companies.api'
import { gridConfig } from '@companies/config/companies.datagrid.config'


const privileges = window.siteVars?.user?.privileges || []
const canManageCompanies =
  privileges.includes('editCompanies') ||
  privileges.includes('editAllCompanies')

const config = {
  ...gridConfig,
  rowsUrl: COMPANIES_API.GET_COMPANIES_V2,
  gridOptions: {
    context: { canManageCompanies },
  },
}

const siteConfigName = COMPANIES_DASHBOARD_CONFIG
</script>
